import { axiosGet, axiosPost } from "../../react_axios/Axios"
import { headers, getAwardQuerywithAnswerCommentsUrl, GET_AWARD_QUERY_WITH_ANSWER_COMMENTS_ACTION_TYPE, insertUpdateAwardQueryUrl, INSERT_UPDATE_AWARD_QUERY_ACTION_TYPE, insertUpdateAwardAnswerUrl, INSERT_UPDATE_AWARD_ANSWER_ACTION_TYPE, insertUpdateAwardCommentUrl, INSERT_UPDATE_AWARD_COMMENT_ACTION_TYPE, user_id, award_event_id } from "../../utils/constants"

export const getAwardQuerywithAnswerComment_action = (award_event_id, award_event_profile_id, application_form_id, title) => async (dispatch) => {
    console.log(award_event_id, award_event_profile_id, application_form_id, '3333333333333')

    try {
        const mapdata = {
            user_id: sessionStorage.getItem('user_id'), award_event_id: award_event_id, award_event_profile_id: award_event_profile_id, application_form_id: application_form_id, title: title
        }
        const res = await axiosGet(getAwardQuerywithAnswerCommentsUrl, mapdata, headers);
        dispatch({
            type: GET_AWARD_QUERY_WITH_ANSWER_COMMENTS_ACTION_TYPE,
            payload: res,
        });
        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};

export const insertUpdateAwardQuery_action =
    (question_id, award_event_id, award_event_profile_id, application_form_id,
        title, content, question_type, call_back_time, queryTo, senderName, senderEmail) =>
        async (dispatch) => {
            try {
                const mapdata = {
                    user_id: sessionStorage.getItem('user_id'),
                    question_id: question_id != null ? question_id : null,
                    award_event_id: award_event_id, award_event_profile_id: award_event_profile_id,
                    application_form_id: application_form_id,
                    title: title != '' ? title : "", question_type: call_back_time != '' ? 'call' : 'query',
                    content: content != '' ? content : '',
                    question_type: question_type,
                    call_back_time: call_back_time != null ? call_back_time : null,
                    role_id: sessionStorage.getItem('role_id') ? parseInt(sessionStorage.getItem('role_id')) : null,
                    queryTo: queryTo ? parseInt(queryTo) : null,
                    senderName: senderName ? senderName : sessionStorage.getItem('user_name'),
                    senderEmail: senderEmail ? senderEmail : sessionStorage.getItem('email_address')
                };
                const res = await axiosPost(insertUpdateAwardQueryUrl, mapdata, headers);
                dispatch({
                    type: INSERT_UPDATE_AWARD_QUERY_ACTION_TYPE,
                    payload: res,
                });
                return Promise.resolve(res);
            } catch (err) {
                return Promise.reject(err);
            }
        };

export const insertUpdateAwardAnswer_action =
    (question_id, answer_id, content, application_form_id, senderName, senderEmail, role_id, queryTo) =>
        async (dispatch) => {
            try {
                const mapdata = {
                    user_id: sessionStorage.getItem('user_id'),
                    answer_id: answer_id != null ? answer_id : null,
                    question_id: question_id,
                    content: content != "" ? content : "",
                    application_form_id: application_form_id,
                    award_event_id: sessionStorage.getItem('award_event_id'),
                    senderName, senderEmail,
                    role_id: role_id ? parseInt(role_id) : null,
                    queryTo: queryTo ? parseInt(queryTo) : null
                };
                const res = await axiosPost(insertUpdateAwardAnswerUrl, mapdata, headers);
                dispatch({
                    type: INSERT_UPDATE_AWARD_ANSWER_ACTION_TYPE,
                    payload: res,
                });
                return Promise.resolve(res);
            } catch (err) {
                return Promise.reject(err);
            }
        };

export const insertUpdateAwardComment_action =
    (comment_id, answer_id, content) =>
        async (dispatch) => {
            try {
                const mapdata = {
                    user_id: sessionStorage.getItem('user_id'),
                    comment_id: comment_id != null ? comment_id : null,
                    answer_id: answer_id,
                    content: content != '' ? content : ''
                };
                const res = await axiosPost(insertUpdateAwardCommentUrl, mapdata, headers);
                dispatch({
                    type: INSERT_UPDATE_AWARD_COMMENT_ACTION_TYPE,
                    payload: res,
                });
                return Promise.resolve(res);
            } catch (err) {
                return Promise.reject(err);
            }
        };
